// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { polyfill } from '@jsmini/console'
polyfill()
import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store/index'
import iView from 'iview'    //引入ivew库
import 'iview/dist/styles/iview.css'    // 使用 CSS
import '@/styles/index.less'
import '@/theme/index.less'

import '@/libs/vue-filters'

import SimpleModal from '@/components/simple-modal/index'

Vue.prototype.$Tip = SimpleModal

Vue.use(iView)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

